import { render, staticRenderFns } from "./shangye.vue?vue&type=template&id=33bb44e2&scoped=true"
import script from "./shangye.vue?vue&type=script&lang=js"
export * from "./shangye.vue?vue&type=script&lang=js"
import style0 from "./shangye.vue?vue&type=style&index=0&id=33bb44e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bb44e2",
  null
  
)

export default component.exports